export const MODIFY_UTILITIES_MENU_ITEM = 'MODIFY_UTILITIES_MENU_ITEM';

export function modifyUtilitiesMenuItem(utilitiesMenuItem){
    return{
        type: MODIFY_UTILITIES_MENU_ITEM,
        mainState: {
            utilitiesMenuItem: utilitiesMenuItem
        }
    }
}